import { render, staticRenderFns } from "./MeasurementFilter.vue?vue&type=template&id=2b1b30b4"
import script from "./MeasurementFilter.vue?vue&type=script&lang=js"
export * from "./MeasurementFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports